import React, { useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import styles from './tableLoadingArea.module.scss';

// Zajednicki "ucitavanje" prikaz za sve tabele: blag veo preko tabele sa
// spinerom. Pojavljuje se tek posle kratkog odlaganja (CSS), pa brza
// ucitavanja ne trepnu.
//
// - Pri ponovnom ucitavanju (strana, filter) postojeci redovi ostaju vidljivi
//   ispod providnog vela.
// - Dok prvo ucitavanje nije zavrseno (nema jos podataka), veo je neproziran,
//   pa se ne vidi "Trenutno nema podataka" pre nego sto podaci stignu.
const TableLoadingArea = ({ loading = false, isEmpty, children }) => {
  const [hasSettled, setHasSettled] = useState(false);
  const wasLoadingRef = useRef(false);

  useEffect(() => {
    if (loading) {
      wasLoadingRef.current = true;
    } else if (wasLoadingRef.current) {
      setHasSettled(true);
    }
  }, [loading]);

  // Prvo ucitavanje: pre prvog zavrsenog zahteva (a bez podataka) tabela jos
  // nije "prazna", nego se ucitava.
  const isInitialLoad = !hasSettled && isEmpty !== false;
  const showLoader = loading || isInitialLoad;
  const opaque = showLoader && isEmpty !== false;

  return (
    <div
      className={`${styles.area} ${showLoader && opaque ? styles.areaEmpty : ''}`}
      aria-busy={showLoader}
    >
      {children}
      {showLoader && (
        <div
          className={`${styles.overlay} ${opaque ? styles.overlayOpaque : ''}`}
          role="status"
        >
          <div className={styles.indicator}>
            <Spin />
            <span className={styles.label}>Učitavanje...</span>
          </div>
        </div>
      )}
    </div>
  );
};

TableLoadingArea.propTypes = {
  loading: PropTypes.bool,
  // true/false kada je poznato da li tabela ima redova; undefined = nepoznato
  // (tada se ponasa kao da je prazna dok traje prvo ucitavanje).
  isEmpty: PropTypes.bool,
  children: PropTypes.node,
};

export default TableLoadingArea;
